export default class extends HTMLElement {

  static get observedAttributes() {
    return ['service'];
  }

  constructor() {
    super();
    console.log('Init DSBTasks');
    this.tasks = [];
    this.hooks = {};
  }

  init()
  {
     this.setAttribute(`id`, 'dsb-tasks_'+this._createUUID());
  }

  get service() {
      return this.getAttribute('service');
  }

  set service(newValue){
      this.setAttribute('service', newValue);
  }

  get header() {
      return this.getAttribute('header');
  }

  set header(newValue){
      this.setAttribute('header', newValue);
  }

  get target_modal() {
      return this.getAttribute('target_modal');
  }

  set target_modal(newValue){
      this.setAttribute('target_modal', newValue);
  }

  get target_panel() {
      return this.getAttribute('target_panel');
  }

  set target_panel(newValue){
      this.setAttribute('target_panel', newValue);
  }

  setDSBClient(dsbClient){
      this.dsbClient=dsbClient;
  }

  addTask(data){
      this.tasks.push(data);
      return this.tasks.length-1;
  }

  addHook(name,action){
      this.hooks[name] = action;
  }

  getTask(id)
  {
    try
    {
      if(isNaN(id))
      {
        id = id.split('-');
        let task = this.tasks[id[0]];
        if(id[1])
        {
          if('parts' in task)
          {
            return task.parts[id[1]];
          }
        }
        return task;
      }
      else
      {
        return this.tasks[id];
      }
    }
    catch(ex)
    {
        throw ex;
    }
  }

  openByTaskNo(task_no)
  {
    document.getElementById(this.id+`_task_`+task_no).dispatchEvent(new MouseEvent("click", {
          "view": window,
          "bubbles": true,
          "cancelable": false
    }));
  }

  setDSBClient(dsbClient){
      this.dsbClient=dsbClient;
  }

  connectedCallback()
  {
    return this._render();
  }

  attributeChangedCallback(name, oldValue, newValue)
  {
    console.log('attributeChangedCallback..'+name);
    return this._render();
  }

  _createUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  setDone(task_no,state=true)
  {
    if(task_no in this.tasks)
    {
      this.tasks[task_no].done = state;
      let item = document.getElementById(this.id+'_task_'+task_no);
      if(state)
      {
        item.classList.add('done');
      }
      else
      {
        item.classList.remove('done');
      }
      return true;
    }
    return false;
  }

  getNextNotDoneTaskId()
  {
    for(let task_id in this.tasks)
    {
      if('done' in this.tasks[task_id])
      {
        if(this.tasks[task_id].done == false)
        {
          if(`parts` in this.tasks[task_id])
          {
            for(let i = 0; i<this.tasks[task_id].parts.length; i++)
            {
              if(`done` in this.tasks[task_id].parts[i])
              {
                if(this.tasks[task_id].parts[i].done == false)
                {
                  if(i != 0)
                  {
                    return this.id+`_task_`+task_id+`-`+i;
                  }
                }
              }
            }
          }
          // We dont want to include the 1st as thats where we started
          if(task_id != 0)
          {
            return this.id+`_task_`+task_id;
          }
        }
      }
    }
    false;
  }

  refreshActive()
  {
    for(var task in this.tasks)
    {
      if(this.tasks[task].active)
      {
        document.getElementById(this.id+`_task_`+task).dispatchEvent(new MouseEvent("click", {
              "view": window,
              "bubbles": true,
              "cancelable": false
          }));
      }

      if(`parts` in this.tasks[task])
      {
        for(let i = 0; i < this.tasks[task].parts.length; i++)
        {
          if(this.tasks[task].parts[i].active)
          {
            document.getElementById(this.id+`_task_`+task+`-`+i).dispatchEvent(new MouseEvent("click", {
                  "view": window,
                  "bubbles": true,
                  "cancelable": false
              }));
          }
        }
      }
    }

  }

  async _render()
  {

    this.innerHTML = `<maa-spinner></maa-spinner>`;

    var on_click = function()
    {
        let controller = document.getElementById(this.getAttribute("data-controller_id"));
        let target_modal = controller.getAttribute("data-target_modal");
        let target_modal_panel = controller.getAttribute("data-target_modal_panel");
        let target_panel = controller.getAttribute("data-target_panel");
        let task_id = this.getAttribute("data-task_id");
        let has_parts = this.getAttribute("data-has_parts");
        let task = controller.getTask(task_id);
        task.task_id = task_id;
        let target_id = target_panel;
        let target_type = 'dsb-panel';
        if(controller.getAttribute("data-target_type"))
        {
          target_type = controller.getAttribute("data-target_type");
        }

        let modal_mode = false;

        if('dsbClient' in controller && typeof controller.dsbClient === 'object' && controller.dsbClient !== null)
        {
          modal_mode = controller.dsbClient.user.env.isViewport([`small`,`xsmall`]);
        }

        // Set active item
        let menu_li = this.parentElement.querySelectorAll(`li`);
        if(menu_li !== undefined || menu_li.length > 0)
        {
          for(let i = 0; i < menu_li.length; i++)
          {
            if(menu_li[i].classList.contains('active'))
            {
              menu_li[i].classList.remove('active');
              let menu_li_sub = menu_li[i].querySelectorAll(`ol`);
              for(let ii = 0; ii < menu_li_sub.length; ii++)
              {
                menu_li_sub[ii].style.display='none';
              }
            }
            if(!menu_li[i].onclick)
            {
              menu_li[i].onclick = this.onclick;
            }
          }
        }
        this.classList.add('active');

        if(has_parts == 'true')
        {
            let parts = this.querySelectorAll(`ol`);
            for(let ii = 0; ii < parts.length; ii++)
            {
              parts[ii].style.display='block';
            }
            this.onclick = false;
            document.getElementById(this.id+'-0').dispatchEvent(new MouseEvent("click", {
                  "view": window,
                  "bubbles": true,
                  "cancelable": false
            }));
            return;
        }

        try
        {
          //if(document.querySelector('dsb-app').env.isViewport([`small`,`xsmall`]))
          if('modal_mode' in task)
          {
            modal_mode = task.modal_mode;
          }

          if(modal_mode)
          {
            target_id = target_modal_panel;
            target_type = 'dsb-modal';
          }
        }
        catch(ex)
        {
          console.error(`dsb-task:: Missing dsb-app.`,ex);
        }

        if(target_id)
        {
          let target =  document.getElementById(target_id);
          target.innerHTML = ``;
          if(target)
          {
            if('route' in controller.hooks)
            {
              controller.hooks.route(target, task);
            }
          }
          else
          {
            console.error('dsb-task:: Cannot find target_id = '+target_id);
          }

          if('dsb-modal' == target_type)
          {
            let modal =  document.getElementById(target_modal);
            if(modal)
            {
              if(!modal.classList.contains('show'))
              {
                modal.classList.toggle('show');
              }
            }
            else
            {
              console.error('dsb-task:: Missing modal('+target_modal+')!',modal);
            }
          }
          else
          {
            let dsb_modal = document.querySelector('dsb-modal');
            if(dsb_modal.classList.contains('show'))
            {
              dsb_modal.classList.toggle('show');
            }
          }
        }
        else
        {
          if('route' in controller.hooks)
          {
            controller.hooks.route('', task);
          }
          if('window' == target_type && ('hash_url' in task))
          {
            window.location.hash = '/'+task.hash_url;
          }
          console.warn('dsb-task:: Missing target_id!');
        }
    };


    var task_panel = document.createElement("ol");

    for(let i = 0; i < this.tasks.length; i++)
    {

      let _link = document.createElement("li");

      if('hidden' in this.tasks[i])
      {
          if(this.tasks[i].hidden)
          {
            _link.setAttribute('style','display:none;');
          }
      }

      if(['quiz','read'].includes(this.tasks[i].type))
      {
        _link.classList.add(`icon-check-circ`);
      }
      else if(['overview'].includes(this.tasks[i].type))
      {
        _link.classList.add(`icon-dashboard`);
        _link.classList.add(`overview`);
        _link.classList.add(`category-bg-color-light`);
      }
      else if('task' == this.tasks[i].type)
      {
        _link.classList.add(`icon-check-box-outline-blank`);
      }

      if(`done` in this.tasks[i])
      {
        if(this.tasks[i].done == true)
        {
            _link.classList.add('done');
        }
      }
      _link.innerHTML = this.tasks[i].name;
      _link.setAttribute(`data-controller_id`, this.id);
      _link.setAttribute(`data-task_id`, i);
      _link.setAttribute(`data-has_parts`, false);
      _link.onclick = on_click;
      _link.setAttribute(`id`, this.id+`_task_`+i);
      if((i+1) < this.tasks.length)
      {
        this.tasks[i].next_id = this.id+`_task_`+(i+1);
      }
      else
      {
        if(['read'].includes(this.tasks[i].type))
        {
          this.tasks[i].next_id = this.id+`_task_0`;
        }
      }

      if((i-1) >= 0)
      {
        this.tasks[i].back_id = this.id+`_task_`+(i-1);
      }

      if(`parts` in this.tasks[i])
      {
        let sub_tasks = document.createElement("ol");

        for(let ii = 0; ii < this.tasks[i].parts.length; ii++)
        {
          let _link = document.createElement("li");
          _link.classList.add(`icon-check-circ`);
          if(`done` in this.tasks[i].parts[ii])
          {
            if(this.tasks[i].parts[ii].done == true)
            {
                _link.classList.add('done');
            }
          }

          _link.innerHTML = this.tasks[i].parts[ii].name;
          _link.onclick = on_click;
          _link.setAttribute(`data-controller_id`, this.id);
          _link.setAttribute(`data-task_id`, i+`-`+ii);
          _link.setAttribute(`id`, this.id+`_task_`+_link.getAttribute(`data-task_id`));
          sub_tasks.append(_link);
          if((ii+1) < this.tasks.length)
          {
            this.tasks[i].parts[ii].next_id = this.id+`_task_`+i+`-`+(ii+1);
          }
          if((ii-1) >= 0)
          {
            this.tasks[i].parts[ii].back_id = this.id+`_task_`+i+`-`+(ii-1);
          }
        }
        sub_tasks.style.display='none';
        _link.setAttribute(`data-has_parts`, true);
        _link.append(sub_tasks);
        if((i+1) < this.tasks.length)
        {
          this.tasks[i].next_id = this.id+`_task_`+i+`-0`;
        }
      }

      let task_name = 'Unknown';

      if('name' in this.tasks[i] && this.tasks[i].name !== null)
      {
        task_name = this.tasks[i].name;
      }

      if('last_update' in this.tasks[i] && this.tasks[i].last_update !== null)
      {
        if('dsbClient' in this && typeof this.dsbClient === 'object' && this.dsbClient !== null)
        {
          let since_object = await this.dsbClient.user.format_date(this.tasks[i].last_update,'since');
          let since_string = '';

          if(since_object.years > 0)
          {
            since_string = since_object.years;

            if(since_object.years > 1)
            {
              since_string="over "+ since_string+" years ago";
            }
            else
            {
              since_string="over "+ since_string+" year ago";
            }
          }
          else if(since_object.months > 0)
          {
            since_string = since_object.months;

            if(since_object.months > 1)
            {
              since_string="over "+ since_string+" months ago";
            }
            else
            {
              since_string="over "+ since_string+" month ago";
            }
          }
          else if(since_object.weeks > 0)
          {
            since_string = since_object.weeks;

            if(since_object.weeks > 1)
            {
              since_string="over "+ since_string+" weeks ago";
            }
            else
            {
              since_string="over "+ since_string+" week ago";
            }
          }
          else if(since_object.days > 0)
          {
            since_string = since_object.days;

            if(since_object.days > 1)
            {
              since_string=since_string+" days ago";
            }
          }

          if(since_string.length > 0)
          {
            if(since_object.total > 14)
            {
              task_name=task_name+"<span class=\"since alert\">Last updated: "+since_string+"</span>";
            }
            else
            {
              task_name=task_name+"<span class=\"since\">Last updated: "+since_string+"</span>";
            }
          }
        }
        else
        {
          task_name=task_name+"<span class=\"since\">Last updated: "+this.tasks[i].last_update+"</span>";
          console.error('Missing dsbClient');
        }
      }

      if('progress' in this.tasks[i] && this.tasks[i].progress !== null)
      {
          let title = document.createElement("span");
          title.setAttribute('style','width:70%;font-size:13px;');
          title.innerHTML = task_name;
          let progress_bar = document.createElement("span");
          progress_bar.classList.add('progress');
          progress_bar.setAttribute('style','width:20%;');
          progress_bar.innerHTML = "<span style=\"width:"+this.tasks[i].progress+"%\">&nbsp;</span>";
          let progress_label = document.createElement("span");
          progress_label.setAttribute('style','width:10%;padding-left:5px;');
          progress_label.innerHTML =this.tasks[i].progress+"%";
          _link.innerHTML = '';
          _link.append(title);
          _link.append(progress_bar);
          _link.append(progress_label);
      }

      task_panel.append(_link);
    }

    this.innerHTML = ``;
    if('header' in this && this.header !==null )
    {
      this.innerHTML = `<h3>`+this.header+`</h3>`;
    }
    this.append(task_panel);

    if(typeof this.hooks === 'object' && this.hooks !== null && ('on_render_complete' in this.hooks))
    {
      this.hooks['on_render_complete']();
    }

    return;
  }
}


